// Full 36-week environmental education curriculum
// Based on the Green Club Activities document

export const ENVIRONMENTAL_DAYS = {
  cleanEnergy: { name: 'Clean Energy Day', date: '2026-01-26', icon: 'sun', points: 50 },
  wetlands: { name: 'World Wetlands Day', date: '2026-02-02', icon: 'droplets', points: 50 },
  wildlife: { name: 'World Wildlife Day', date: '2026-03-03', icon: 'paw', points: 50 },
  recycling: { name: 'Global Recycling Day', date: '2026-03-18', icon: 'recycle', points: 50 },
  forests: { name: 'International Day of Forests', date: '2026-03-21', icon: 'trees', points: 50 },
  water: { name: 'World Water Day', date: '2026-03-22', icon: 'droplet', points: 50 },
  earthHour: { name: 'Earth Hour', date: '2026-03-28', icon: 'moon', points: 50 },
  zeroWaste: { name: 'Zero Waste Day', date: '2026-03-30', icon: 'trash-off', points: 50 },
  earth: { name: 'Earth Day', date: '2026-04-22', icon: 'globe', points: 100 },
  bee: { name: 'World Bee Day', date: '2026-05-20', icon: 'bee', points: 50 },
  biodiversity: { name: 'International Day for Biological Diversity', date: '2026-05-22', icon: 'leaf', points: 50 },
  environment: { name: 'World Environment Day', date: '2026-06-05', icon: 'tree', points: 100 },
  oceans: { name: 'World Oceans Day', date: '2026-06-08', icon: 'waves', points: 50 },
  desertification: { name: 'World Day to Combat Desertification', date: '2026-06-17', icon: 'sun', points: 50 },
  mangrove: { name: 'International Day for the Conservation of the Mangrove', date: '2026-07-26', icon: 'tree', points: 50 },
  cleanAir: { name: 'International Day of Clean Air', date: '2026-09-07', icon: 'wind', points: 50 },
  ozone: { name: 'International Day for the Preservation of the Ozone Layer', date: '2026-09-16', icon: 'shield', points: 50 },
  coastalCleanup: { name: 'International Coastal Cleanup Day', date: '2026-09-19', icon: 'waves', points: 50 },
  worldCleanup: { name: 'World Cleanup Day', date: '2026-09-20', icon: 'trash', points: 50 },
  habitat: { name: 'World Habitat Day', date: '2026-10-05', icon: 'home', points: 50 },
  eWaste: { name: 'International E-Waste Day', date: '2026-10-14', icon: 'smartphone', points: 50 },
  food: { name: 'World Food Day', date: '2026-10-16', icon: 'apple', points: 50 },
  sustainability: { name: 'Sustainability Day', date: '2026-10-28', icon: 'recycle', points: 50 },
};

export const MONTHS_DATA = [
  // TERM 1: January - April
  {
    id: 1,
    name: 'January',
    theme: 'Plant Propagation & Ownership',
    term: 1,
    weeks: [
      {
        number: 1,
        title: 'Propagation Day',
        theme: 'Plant Propagation & Ownership',
        plantCareFocus: 'Seed collection, Planting ceremony, Responsibility introduction',
        status: 'completed',
        activities: [
          { id: 101, title: 'Seed Collection', description: 'Collect seeds from native plants', points: 25 },
          { id: 102, title: 'Plant Naming', description: 'Name your new plant friend', points: 25 },
          { id: 103, title: 'Planting Ceremony', description: 'Plant your seed with care', points: 25 },
          { id: 104, title: 'Create Growth Journal', description: 'Start tracking your plant growth', points: 25 },
        ],
      },
      {
        number: 2,
        title: 'Daily Care Begins',
        theme: 'Plant Propagation & Ownership',
        plantCareFocus: 'Watering training, Sunlight observation, Daily routines',
        status: 'completed',
        activities: [
          { id: 201, title: 'Watering Training', description: 'Learn proper watering techniques', points: 25 },
          { id: 202, title: 'Sunlight Observation', description: 'Find the best spot for sunlight', points: 25 },
          { id: 203, title: 'Daily Check Routine', description: 'Establish morning plant check', points: 25 },
          { id: 204, title: 'Record Observations', description: 'Note any changes in your plant', points: 25 },
        ],
      },
      {
        number: 3,
        title: 'Germination Watch',
        theme: 'Plant Propagation & Ownership',
        plantCareFocus: 'First sprouts, Growth monitoring, Responsibility building',
        status: 'available',
        activities: [
          { id: 301, title: 'Germination Watch', description: 'Look for the first signs of sprouting', points: 25 },
          { id: 302, title: 'Measure Your Sprout', description: 'Record the height of your sprout', points: 25 },
          { id: 303, title: 'Celebrate Sprouting', description: 'Share your excitement with classmates', points: 25 },
          { id: 304, title: 'Daily Care Checklist', description: 'Create and follow a care routine', points: 25 },
        ],
      },
      {
        number: 4,
        title: 'Ownership Established',
        theme: 'Plant Propagation & Ownership',
        plantCareFocus: 'Personal responsibility, Care commitment, Clean Energy Day',
        status: 'locked',
        envDay: ENVIRONMENTAL_DAYS.cleanEnergy,
        activities: [
          { id: 401, title: 'Ownership Certificate', description: 'Create a certificate for your plant', points: 25 },
          { id: 402, title: 'Care Commitment', description: 'Write a care promise', points: 25 },
          { id: 403, title: 'Clean Energy Activity', description: 'Learn about solar energy', points: 25 },
          { id: 404, title: 'Month Review', description: 'Reflect on your progress', points: 25 },
        ],
      },
    ],
  },
  {
    id: 2,
    name: 'February',
    theme: 'Responsibility & Water Systems',
    term: 1,
    weeks: [
      {
        number: 5,
        title: 'Growth Celebration',
        theme: 'Responsibility & Water Systems',
        plantCareFocus: 'Measurements, Comparisons, Growth tracking',
        status: 'locked',
        activities: [
          { id: 501, title: 'Growth Measurement', description: 'Measure and record plant height', points: 25 },
          { id: 502, title: 'Photo Documentation', description: 'Take photos of your plant', points: 25 },
          { id: 503, title: 'Growth Chart', description: 'Create a visual growth chart', points: 25 },
          { id: 504, title: 'Compare with Classmates', description: 'Share and compare plant growth', points: 25 },
        ],
      },
      {
        number: 6,
        title: 'Continued Care',
        theme: 'Responsibility & Water Systems',
        plantCareFocus: 'Water conservation, Wetlands Day activities',
        status: 'locked',
        envDay: ENVIRONMENTAL_DAYS.wetlands,
        activities: [
          { id: 601, title: 'Water Conservation', description: 'Learn about saving water', points: 25 },
          { id: 602, title: 'Wetlands Exploration', description: 'Discover wetland ecosystems', points: 25 },
          { id: 603, title: 'Water Cycle Art', description: 'Create water cycle artwork', points: 25 },
          { id: 604, title: 'Wetlands Day Activity', description: 'Special wetlands celebration', points: 25 },
        ],
      },
      {
        number: 7,
        title: 'Theme: REDUCE',
        theme: 'Reduce, Reuse, Recycle',
        plantCareFocus: 'Waste audit, Waste-free challenge',
        status: 'locked',
        activities: [
          { id: 701, title: 'Waste Audit', description: 'Track waste for one day', points: 25 },
          { id: 702, title: 'Reduce Pledge', description: 'Make a reduction promise', points: 25 },
          { id: 703, title: 'Paper Saving', description: 'Use both sides of paper', points: 25 },
          { id: 704, title: 'Waste-Free Lunch', description: 'Pack a zero-waste lunch', points: 25 },
        ],
      },
      {
        number: 8,
        title: 'Theme: REUSE',
        theme: 'Reduce, Reuse, Recycle',
        plantCareFocus: 'Creative containers, Upcycling projects',
        status: 'locked',
        activities: [
          { id: 801, title: 'Upcycling Project', description: 'Transform waste into art', points: 25 },
          { id: 802, title: 'Reusable Containers', description: 'Decorate reusable containers', points: 25 },
          { id: 803, title: 'Toy Swap', description: 'Organize a toy exchange', points: 25 },
          { id: 804, title: 'Creative Reuse', description: 'Find new uses for old items', points: 25 },
        ],
      },
    ],
  },
  {
    id: 3,
    name: 'March',
    theme: 'MEGA MONTH: 6 Environmental Days!',
    term: 1,
    weeks: [
      {
        number: 9,
        title: 'Theme: RECYCLE',
        theme: 'Reduce, Reuse, Recycle',
        plantCareFocus: 'Recycling basics, Wildlife Day',
        status: 'locked',
        envDay: ENVIRONMENTAL_DAYS.wildlife,
        activities: [
          { id: 901, title: 'Recycling Sorting', description: 'Learn to sort recyclables', points: 25 },
          { id: 902, title: 'Wildlife Protection', description: 'How recycling helps animals', points: 25 },
          { id: 903, title: 'Recycling Art', description: 'Create art from recyclables', points: 25 },
          { id: 904, title: 'Wildlife Day Activity', description: 'Celebrate wildlife', points: 25 },
        ],
      },
      {
        number: 10,
        title: 'Theme: FORESTRY',
        theme: 'Forestry & Trees',
        plantCareFocus: 'Tree planting, Recycling Day, Forests Day',
        status: 'locked',
        envDay: ENVIRONMENTAL_DAYS.forests,
        activities: [
          { id: 1001, title: 'Tree Identification', description: 'Identify trees in your area', points: 25 },
          { id: 1002, title: 'Forest Ecosystem', description: 'Learn about forest ecosystems', points: 25 },
          { id: 1003, title: 'Tree Planting', description: 'Plant a tree seedling', points: 25 },
          { id: 1004, title: 'Forests Day Celebration', description: 'Celebrate our forests', points: 25 },
        ],
      },
      {
        number: 11,
        title: 'FORESTRY Continues',
        theme: 'Forestry & Trees',
        plantCareFocus: 'Tree care, Water Day activities',
        status: 'locked',
        envDay: ENVIRONMENTAL_DAYS.water,
        activities: [
          { id: 1101, title: 'Tree Care', description: 'Learn to care for young trees', points: 25 },
          { id: 1102, title: 'Water for Trees', description: 'How trees use water', points: 25 },
          { id: 1103, title: 'Forest Walk', description: 'Take a nature walk', points: 25 },
          { id: 1104, title: 'Water Day Activity', description: 'Celebrate World Water Day', points: 25 },
        ],
      },
      {
        number: 12,
        title: 'FORESTRY Celebration',
        theme: 'Forestry & Trees',
        plantCareFocus: 'Earth Hour, Zero Waste Day',
        status: 'locked',
        envDay: ENVIRONMENTAL_DAYS.zeroWaste,
        activities: [
          { id: 1201, title: 'Earth Hour Prep', description: 'Plan for Earth Hour', points: 25 },
          { id: 1202, title: 'Zero Waste Challenge', description: 'One day zero waste', points: 25 },
          { id: 1203, title: 'Forest Art', description: 'Create forest-themed art', points: 25 },
          { id: 1204, title: 'Term 1 Celebration', description: 'Celebrate your achievements', points: 25 },
        ],
      },
    ],
  },
  // TERM 2: April - July
  {
    id: 4,
    name: 'April',
    theme: 'Earth Day & Global Mobilization',
    term: 2,
    weeks: [
      {
        number: 13,
        title: 'Theme: WATER',
        theme: 'Water Conservation',
        plantCareFocus: 'Water conservation basics',
        status: 'locked',
        activities: [
          { id: 1301, title: 'Water Audit', description: 'Track water usage', points: 25 },
          { id: 1302, title: 'Water Saving Tips', description: 'Learn conservation tips', points: 25 },
          { id: 1303, title: 'Rain Collection', description: 'Set up rain collection', points: 25 },
          { id: 1304, title: 'Water Quiz', description: 'Test your water knowledge', points: 25 },
        ],
      },
      {
        number: 14,
        title: 'Water Continues',
        theme: 'Water Conservation',
        plantCareFocus: 'Water cycle, EARTH DAY',
        status: 'locked',
        envDay: ENVIRONMENTAL_DAYS.earth,
        activities: [
          { id: 1401, title: 'Water Cycle Study', description: 'Learn about the water cycle', points: 25 },
          { id: 1402, title: 'Earth Day Pledge', description: 'Make an Earth Day promise', points: 25 },
          { id: 1403, title: 'Earth Day Project', description: 'Complete a special project', points: 25 },
          { id: 1404, title: 'Earth Day Celebration', description: 'Celebrate Earth Day!', points: 25 },
        ],
      },
      {
        number: 15,
        title: 'Theme: EARTH PROTECTION',
        theme: 'Earth Protection',
        plantCareFocus: 'Soil health, Earth care',
        status: 'locked',
        activities: [
          { id: 1501, title: 'Soil Study', description: 'Learn about healthy soil', points: 25 },
          { id: 1502, title: 'Composting Basics', description: 'Start composting', points: 25 },
          { id: 1503, title: 'Erosion Prevention', description: 'Understand erosion', points: 25 },
          { id: 1504, title: 'Earth Art', description: 'Create earth-themed art', points: 25 },
        ],
      },
      {
        number: 16,
        title: 'Earth Protection',
        theme: 'Earth Protection',
        plantCareFocus: 'Pollinator support, World Bee Day',
        status: 'locked',
        envDay: ENVIRONMENTAL_DAYS.bee,
        activities: [
          { id: 1601, title: 'Bee Observation', description: 'Watch bees at work', points: 25 },
          { id: 1602, title: 'Pollinator Garden', description: 'Plan a bee-friendly garden', points: 25 },
          { id: 1603, title: 'Bee Facts', description: 'Learn amazing bee facts', points: 25 },
          { id: 1604, title: 'World Bee Day', description: 'Celebrate bees!', points: 25 },
        ],
      },
    ],
  },
  {
    id: 5,
    name: 'May',
    theme: 'Biodiversity & Ocean Connections',
    term: 2,
    weeks: [
      {
        number: 17,
        title: 'Earth Protection',
        theme: 'Biodiversity',
        plantCareFocus: 'Biodiversity Day, Species diversity',
        status: 'locked',
        envDay: ENVIRONMENTAL_DAYS.biodiversity,
        activities: [
          { id: 1701, title: 'Species Count', description: 'Count species in your area', points: 25 },
          { id: 1702, title: 'Biodiversity Map', description: 'Map local biodiversity', points: 25 },
          { id: 1703, title: 'Habitat Creation', description: 'Create a mini habitat', points: 25 },
          { id: 1704, title: 'Biodiversity Day', description: 'Celebrate biodiversity!', points: 25 },
        ],
      },
      {
        number: 18,
        title: 'Theme: POLLUTION',
        theme: 'Pollution Awareness',
        plantCareFocus: 'Pollution observation',
        status: 'locked',
        activities: [
          { id: 1801, title: 'Pollution Survey', description: 'Survey pollution in your area', points: 25 },
          { id: 1802, title: 'Air Quality', description: 'Learn about air quality', points: 25 },
          { id: 1803, title: 'Water Pollution', description: 'Understand water pollution', points: 25 },
          { id: 1804, title: 'Cleanup Planning', description: 'Plan a cleanup activity', points: 25 },
        ],
      },
      {
        number: 19,
        title: 'Pollution Continues',
        theme: 'Pollution Awareness',
        plantCareFocus: 'Pollution solutions',
        status: 'locked',
        activities: [
          { id: 1901, title: 'Pollution Solutions', description: 'Research solutions', points: 25 },
          { id: 1902, title: 'Litter Pickup', description: 'Clean up your area', points: 25 },
          { id: 1903, title: 'Awareness Poster', description: 'Create an awareness poster', points: 25 },
          { id: 1904, title: 'Share Solutions', description: 'Share with classmates', points: 25 },
        ],
      },
      {
        number: 20,
        title: 'Pollution Celebration',
        theme: 'Environment & Oceans',
        plantCareFocus: 'World Environment Day, Oceans Day',
        status: 'locked',
        envDay: ENVIRONMENTAL_DAYS.environment,
        activities: [
          { id: 2001, title: 'Environment Day Prep', description: 'Prepare for celebration', points: 25 },
          { id: 2002, title: 'Ocean Connection', description: 'How pollution affects oceans', points: 25 },
          { id: 2003, title: 'Environment Day', description: 'Celebrate our environment!', points: 25 },
          { id: 2004, title: 'Oceans Day', description: 'Celebrate our oceans!', points: 25 },
        ],
      },
    ],
  },
  {
    id: 6,
    name: 'June',
    theme: 'Biodiversity & Plastic-Free',
    term: 2,
    weeks: [
      {
        number: 21,
        title: 'Theme: BIODIVERSITY',
        theme: 'Biodiversity',
        plantCareFocus: 'Desertification Day, Ecosystem balance',
        status: 'locked',
        envDay: ENVIRONMENTAL_DAYS.desertification,
        activities: [
          { id: 2101, title: 'Desert Ecosystems', description: 'Learn about deserts', points: 25 },
          { id: 2102, title: 'Fighting Desertification', description: 'How to combat deserts', points: 25 },
          { id: 2103, title: 'Plant More Trees', description: 'Trees fight desertification', points: 25 },
          { id: 2104, title: 'Desertification Day', description: 'Raise awareness', points: 25 },
        ],
      },
      {
        number: 22,
        title: 'Biodiversity',
        theme: 'Plastic-Free July Prep',
        plantCareFocus: 'Plastic-free preparation',
        status: 'locked',
        activities: [
          { id: 2201, title: 'Plastic Audit', description: 'Count your plastic use', points: 25 },
          { id: 2202, title: 'Plastic Alternatives', description: 'Find plastic alternatives', points: 25 },
          { id: 2203, title: 'Plastic-Free Plan', description: 'Plan for July', points: 25 },
          { id: 2204, title: 'Share Your Plan', description: 'Tell others about going plastic-free', points: 25 },
        ],
      },
      {
        number: 23,
        title: 'Theme: ADVANCED CARE',
        theme: 'Advanced Plant Care',
        plantCareFocus: 'Mangrove Day, Advanced techniques',
        status: 'locked',
        envDay: ENVIRONMENTAL_DAYS.mangrove,
        activities: [
          { id: 2301, title: 'Mangrove Ecosystems', description: 'Learn about mangroves', points: 25 },
          { id: 2302, title: 'Advanced Watering', description: 'Master watering techniques', points: 25 },
          { id: 2303, title: 'Plant Health Check', description: 'Diagnose plant issues', points: 25 },
          { id: 2304, title: 'Mangrove Day', description: 'Celebrate mangroves!', points: 25 },
        ],
      },
      {
        number: 24,
        title: 'Advanced Care',
        theme: 'Propagation Mastery',
        plantCareFocus: 'Propagation mastery, Term 2 celebration',
        status: 'locked',
        activities: [
          { id: 2401, title: 'Propagation Review', description: 'Review propagation techniques', points: 25 },
          { id: 2402, title: 'New Plant Start', description: 'Propagate a new plant', points: 25 },
          { id: 2403, title: 'Plant Gifting', description: 'Gift a plant to someone', points: 25 },
          { id: 2404, title: 'Term 2 Celebration', description: 'Celebrate your achievements!', points: 25 },
        ],
      },
    ],
  },
  // TERM 3: September - December
  {
    id: 7,
    name: 'September',
    theme: 'Major Cleanup & Air Quality',
    term: 3,
    weeks: [
      {
        number: 25,
        title: 'Theme: LEADERSHIP',
        theme: 'Environmental Leadership',
        plantCareFocus: 'Clean Air Day, Leadership skills',
        status: 'locked',
        envDay: ENVIRONMENTAL_DAYS.cleanAir,
        activities: [
          { id: 2501, title: 'Air Quality Study', description: 'Measure local air quality', points: 25 },
          { id: 2502, title: 'Leadership Workshop', description: 'Develop leadership skills', points: 25 },
          { id: 2503, title: 'Clean Air Pledge', description: 'Make a clean air promise', points: 25 },
          { id: 2504, title: 'Clean Air Day', description: 'Celebrate clean air!', points: 25 },
        ],
      },
      {
        number: 26,
        title: 'Leadership',
        theme: 'Ozone Protection',
        plantCareFocus: 'Ozone Layer Day',
        status: 'locked',
        envDay: ENVIRONMENTAL_DAYS.ozone,
        activities: [
          { id: 2601, title: 'Ozone Study', description: 'Learn about the ozone layer', points: 25 },
          { id: 2602, title: 'CFC Awareness', description: 'Understand harmful chemicals', points: 25 },
          { id: 2603, title: 'Protection Actions', description: 'How to protect ozone', points: 25 },
          { id: 2604, title: 'Ozone Day', description: 'Celebrate ozone protection!', points: 25 },
        ],
      },
      {
        number: 27,
        title: 'Leadership',
        theme: 'Cleanup Actions',
        plantCareFocus: 'Coastal Cleanup, World Cleanup Day',
        status: 'locked',
        envDay: ENVIRONMENTAL_DAYS.worldCleanup,
        activities: [
          { id: 2701, title: 'Cleanup Planning', description: 'Plan a cleanup event', points: 25 },
          { id: 2702, title: 'Coastal Cleanup', description: 'Clean a beach or waterway', points: 25 },
          { id: 2703, title: 'Data Collection', description: 'Record what you find', points: 25 },
          { id: 2704, title: 'World Cleanup Day', description: 'Join the global cleanup!', points: 25 },
        ],
      },
      {
        number: 28,
        title: 'Leadership Celebration',
        theme: 'Leadership Recognition',
        plantCareFocus: 'Leadership recognition, Reflection',
        status: 'locked',
        activities: [
          { id: 2801, title: 'Leadership Showcase', description: 'Share your leadership story', points: 25 },
          { id: 2802, title: 'Mentor Others', description: 'Help younger students', points: 25 },
          { id: 2803, title: 'Future Plans', description: 'Plan future green actions', points: 25 },
          { id: 2804, title: 'Celebration', description: 'Celebrate leadership!', points: 25 },
        ],
      },
    ],
  },
  {
    id: 8,
    name: 'October',
    theme: 'Habitat, Food & Sustainability',
    term: 3,
    weeks: [
      {
        number: 29,
        title: 'Theme: REFLECTION',
        theme: 'Habitat & Reflection',
        plantCareFocus: 'World Habitat Day, Year reflection',
        status: 'locked',
        envDay: ENVIRONMENTAL_DAYS.habitat,
        activities: [
          { id: 2901, title: 'Habitat Study', description: 'Explore local habitats', points: 25 },
          { id: 2902, title: 'Habitat Creation', description: 'Build a wildlife habitat', points: 25 },
          { id: 2903, title: 'Year Reflection', description: 'Reflect on your journey', points: 25 },
          { id: 2904, title: 'Habitat Day', description: 'Celebrate habitats!', points: 25 },
        ],
      },
      {
        number: 30,
        title: 'Reflection',
        theme: 'E-Waste & Food',
        plantCareFocus: 'E-Waste Day, World Food Day',
        status: 'locked',
        envDay: ENVIRONMENTAL_DAYS.food,
        activities: [
          { id: 3001, title: 'E-Waste Audit', description: 'Find old electronics', points: 25 },
          { id: 3002, title: 'Proper Disposal', description: 'Learn proper e-waste disposal', points: 25 },
          { id: 3003, title: 'Food Waste Reduction', description: 'Reduce food waste', points: 25 },
          { id: 3004, title: 'World Food Day', description: 'Celebrate responsibly!', points: 25 },
        ],
      },
      {
        number: 31,
        title: 'Reflection',
        theme: 'Sustainability',
        plantCareFocus: 'Sustainability Day',
        status: 'locked',
        envDay: ENVIRONMENTAL_DAYS.sustainability,
        activities: [
          { id: 3101, title: 'Sustainability Audit', description: 'Assess your sustainability', points: 25 },
          { id: 3102, title: 'Sustainable Choices', description: 'Make sustainable choices', points: 25 },
          { id: 3103, title: 'Future Planning', description: 'Plan sustainable future', points: 25 },
          { id: 3104, title: 'Sustainability Day', description: 'Celebrate sustainability!', points: 25 },
        ],
      },
      {
        number: 32,
        title: 'SHOWCASE',
        theme: 'Exhibition & Final Celebration',
        plantCareFocus: 'Year-end exhibition, Final celebration',
        status: 'locked',
        activities: [
          { id: 3201, title: 'Exhibition Prep', description: 'Prepare your exhibition', points: 25 },
          { id: 3202, title: 'Showcase Setup', description: 'Set up your display', points: 25 },
          { id: 3203, title: 'Present Your Work', description: 'Share with others', points: 25 },
          { id: 3204, title: 'Final Celebration', description: 'Celebrate the year!', points: 25 },
        ],
      },
    ],
  },
];

export const BADGES_DATA = [
  // Achievement Badges
  { id: 1, name: 'First Sprout', description: 'Witness your first seed germination', icon: 'leaf', type: 'achievement', criteria: { weeks_completed: 1 } },
  { id: 2, name: 'Plant Propagation Expert', description: 'Complete all January activities', icon: 'seedling', type: 'achievement', criteria: { month_completed: 1 } },
  { id: 3, name: 'Water Warrior', description: 'Complete Wetlands Day activities', icon: 'droplets', type: 'achievement', criteria: { env_day: 'wetlands' } },
  { id: 4, name: 'Waste Warrior', description: 'Complete Reduce/Reuse/Recycle weeks', icon: 'recycle', type: 'achievement', criteria: { weeks_completed: [7, 8, 9] } },
  { id: 5, name: 'Forest Friend', description: 'Complete the Forestry theme', icon: 'tree-deciduous', type: 'achievement', criteria: { weeks_completed: [10, 11, 12] } },
  { id: 6, name: 'Earth Protector', description: 'Complete Earth Day activities', icon: 'globe', type: 'achievement', criteria: { env_day: 'earth' } },
  { id: 7, name: 'Biodiversity Ambassador', description: 'Complete Biodiversity theme', icon: 'leaf', type: 'achievement', criteria: { weeks_completed: [17, 21] } },
  { id: 8, name: 'Climate Champion', description: 'Complete Climate activities', icon: 'sun', type: 'achievement', criteria: { weeks_completed: [25, 26] } },
  { id: 9, name: 'Community Builder', description: 'Gift 5+ plants to others', icon: 'gift', type: 'achievement', criteria: { plants_gifted: 5 } },

  // Milestone Badges
  { id: 10, name: 'Rising Star', description: 'Earn 500 points', icon: 'star', type: 'milestone', criteria: { points: 500 } },
  { id: 11, name: 'Green Champion', description: 'Earn 2000 points', icon: 'trophy', type: 'milestone', criteria: { points: 2000 } },
  { id: 12, name: 'Eco Master', description: 'Earn 5000 points', icon: 'crown', type: 'milestone', criteria: { points: 5000 } },
  { id: 13, name: 'Green Leader', description: 'Complete all Term 1 activities', icon: 'medal', type: 'milestone', criteria: { term_completed: 1 } },
  { id: 14, name: 'Environmental Expert', description: 'Complete all Term 2 activities', icon: 'award', type: 'milestone', criteria: { term_completed: 2 } },
  { id: 15, name: 'Eco Expert', description: 'Complete the entire year', icon: 'award', type: 'milestone', criteria: { year_completed: true } },

  // Consistency Badges
  { id: 16, name: 'Week Warrior', description: '7-day activity streak', icon: 'flame', type: 'consistency', criteria: { streak_days: 7 } },
  { id: 17, name: 'Master Caregiver', description: '30-day activity streak', icon: 'flame', type: 'consistency', criteria: { streak_days: 30 } },
  { id: 18, name: 'Dedicated Gardener', description: '60-day activity streak', icon: 'flame', type: 'consistency', criteria: { streak_days: 60 } },
];

export default {
  MONTHS_DATA,
  ENVIRONMENTAL_DAYS,
  BADGES_DATA,
};
